import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { edekaTheme } from './edekaTheme';

const edekaThemeExtension = ThemeBlueprint.make({
  name: 'edeka',
  params: {
    theme: {
      id: 'edeka',
      title: 'EDEKA',
      variant: 'light',
      icon: <WbSunnyIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={edekaTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [edekaThemeExtension],
});
